<div fxLayout="column" style="height: 100%" data-cy="recall-print-modal-container">

  <div fxFlex="10" fxLayout="row" style="flex: 1 0 0; max-height: fit-content; padding: 2%" data-cy="recall-print-modal-header">
    <button class="tdo-btn tdo-close" (click)="cancel()" data-cy="recall-print-modal-close-button">Close</button>
    <div fxLayout="column" style="flex: 1 0 0"></div>
    <button class="tdo-btn tdox-btn-primary" (click)="print()" data-cy="recall-print-modal-print-button">Print</button>
  </div>

  <div fxLayout="row" style="flex: 1 0 0" data-cy="recall-print-modal-content">
    <div fxLayout="column" id="printContainer" style=" font-size: 12px; width: 100%; overflow: auto" data-cy="recall-print-modal-print-container">
      @if (patient) {
        <div fxFlex="10" fxLayout="row" style="margin: 2%" data-cy="recall-print-modal-patient-info">
          <mat-label data-cy="recall-print-modal-patient-name">{{patient}}</mat-label>
        </div>
      }
      <div fxLayout="row" style="margin: 2%" data-cy="recall-print-modal-report-section">
        <div fxLayout="column" fxFlex="100" style="overflow: auto; max-height: 33vh" data-cy="recall-print-modal-final-report">
          <div fxLayout="row">
            <mat-label class="leftLabel" data-cy="recall-print-modal-final-report-label">Final Report: </mat-label>
          </div>

          <div fxLayout="row" style="font-size: 12px; margin-top: 3%" data-cy="recall-print-modal-date-completed">
            <div fxFlex="40" fxLayout="column" class="flex-column" style="align-items: end; display: flex; margin-right: 5px" data-cy="recall-print-modal-date-completed-label">
              Date Completed:
            </div>
            <div fxFlex="60" fxLayout="column" class="flex-column" style="align-items: start; display: flex; " data-cy="recall-print-modal-date-completed-value">
              {{finalReport.CompletedDate | date: 'MM-dd-YY'}}
            </div>
          </div>

          <div fxLayout="row" style="font-size: 14px" data-cy="recall-print-modal-pulp-diagnosis">
            <div fxFlex="40" fxLayout="column" class="flex-column" style="align-items: end; display: flex;  margin-right: 5px" data-cy="recall-print-modal-pulp-diagnosis-label">
              Pulp Diagnosis:
            </div>
            <div fxFlex="60" fxLayout="column" class="flex-column" style="align-items: start; display: flex; " data-cy="recall-print-modal-pulp-diagnosis-value">
              {{finalReport.isDiagnosticsLarge}}
            </div>
          </div>

          <div fxLayout="row" style="font-size: 14px" data-cy="recall-print-modal-perlap-diagnosis">
            <div fxFlex="40" fxLayout="column" class="flex-column" style="align-items: end; display: flex; margin-right: 5px" data-cy="recall-print-modal-perlap-diagnosis-label">
              Periap Diagnosis:
            </div>
            <div fxFlex="60" fxLayout="column" class="flex-column" style="align-items: start; display: flex;" data-cy="recall-print-modal-perlap-diagnosis-value">
              {{finalReport.isSendDiagnostics}}
            </div>
          </div>

          <div fxLayout="row" style="font-size: 12px" data-cy="recall-print-modal-second-treatment">
            <div fxFlex="40" fxLayout="column" class="flex-column" style="align-items: end; display: flex; margin-right: 5px" data-cy="recall-print-modal-second-treatment-label">
              2nd Rec'd Trmt:
            </div>
            @for (val of caseTypeEnums | enumDisplay: finalReport.enumCaseTypeID; track val) {
              <div fxFlex="60" fxLayout="column" class="flex-column" style="align-items: start; display: flex;"
                data-cy="recall-print-modal-second-treatment-value">
                {{val.ItemDisplayValue}}
              </div>
            }
          </div>

          <div fxLayout="row" style="font-size: 14px" data-cy="recall-print-modal-prognosis">
            <div fxFlex="40" fxLayout="column" class="flex-column" style="align-items: end; display: flex; margin-right: 5px" data-cy="recall-print-modal-prognosis-label">
              Prognosis:
            </div>
            @for (val of prognosisEnums | enumDisplay: finalReport.enumFinalReportPrognosisID; track val) {
              <div fxFlex="60" fxLayout="column" class="flex-column" style="align-items: start; display: flex;" data-cy="recall-print-modal-prognosis-value">
                {{val.ItemDisplayValue}}
              </div>
            }
          </div>

          <div fxLayout="row" style="font-size: 14px" data-cy="recall-print-modal-rest-recomm">
            <div fxFlex="40" fxLayout="column" class="flex-column" style="align-items: end; display: flex; margin-right: 5px" data-cy="recall-print-modal-rest-recomm-label">
              Rest Recomm:
            </div>
            <div fxFlex="60" fxLayout="column" class="flex-column" style="align-items: start; display: flex;" data-cy="recall-print-modal-rest-recomm-values">
              @for (recom of finalReport.dataPatientCaseEndoFinalReportRestorRecomds; track recom; let d = $index) {
                <div fxLayout="row" data-cy="recall-print-modal-rest-recomm-item">
                  @for (val of restorationMethodEnums | enumDisplay: recom.enumFinalReportRestorationMethodID; track val) {
                    <span data-cy="recall-print-modal-rest-recomm-value">{{d + 1}}. {{val.ItemDisplayValue}}</span>
                  }
                </div>
              }
            </div>
          </div>

          @if (!finalReport) {
            <div fxLayout="row" class="flex-column" style="text-align: left; align-items: start; margin-left: 5px" data-cy="recall-print-modal-no-data">
              No Data
            </div>
          }

        </div>
        <div fxFlex="50" fxLayout="column" data-cy="recall-print-modal-treatment-section">
          <mat-label data-cy="recall-print-modal-treatment-label">Treatment</mat-label>
          <div fxFlex="70" fxLayout="row" class="white" data-cy="recall-print-modal-treatment-content">
            <div fxLayout="column" fxFlex="100">

              <mat-label class="leftLabel" data-cy="recall-print-modal-treatment-header">Treatment: </mat-label>
              <div fxFlex="30" fxLayout="row" style="margin-top: 3%" data-cy="recall-print-modal-treatment-details">

                <div fxFlex="25" fxLayout="column" class="flex-column" style="align-items: end; display: flex;" data-cy="recall-print-modal-treatment-labels">
                  <div fxLayout="row" class="label" data-cy="recall-print-modal-time-label">Time:</div>
                  <div fxLayout="row" class="label" data-cy="recall-print-modal-difficulty-label">Difficulty:</div>
                </div>

                <div fxFlex="20" fxLayout="column" class="flex-column" style="align-items: start; display: flex;" data-cy="recall-print-modal-treatment-values">
                  @for (val of treatmentSessionsEnums | enumDisplay: finalReport.enumTreatmentSessionsID; track val) {
                    <div fxLayout="row" class="entry" data-cy="recall-print-modal-time-value">
                      {{val.ItemDisplayValue}}
                    </div>
                  }
                  @if (finalReport !== null) {
                    <div fxLayout="row" class="entry"></div>
                  }
                  @if (finalReport.enumTreatmentSessionsID === null) {
                    <div fxLayout="row" class="entry" data-cy="recall-print-modal-time-no-data">No Data</div>
                  }
                  @if (finalReport === null) {
                    <div fxLayout="row" class="entry" data-cy="recall-print-modal-time-no-report">No Data</div>
                  }
                </div>

                <div fxFlex="25" fxLayout="column" class="flex-column" style="align-items: end; display: flex; ">
                  <div fxLayout="row" class="label">Q Value:</div>
                  <div fxLayout="row" class="label">P Value:</div>
                </div>


                <div fxFlex="20" fxLayout="column" class="flex-column" style="align-items: start; display: flex; ">
                  @if (finalReport.QValue !== null) {
                    <div fxLayout="row" class="entry">{{finalReport.QValue}}</div>
                  }
                  @if (finalReport.Pvalue !== null) {
                    <div fxLayout="row" class="entry">{{finalReport.Pvalue}}</div>
                  }
                  @if (finalReport.QValue === null) {
                    <div fxLayout="row" class="entry">No Data</div>
                  }
                  @if (finalReport.Pvalue === null) {
                    <div fxLayout="row" class="entry">No Data</div>
                  }
                </div>

              </div>
              <div  fxFlex="10" fxLayout="row">

                <div fxFlex="40" fxLayout="column" class="flex-column" style="flex: 1; display: flex; padding-right: 2%">
                  <div fxLayout="row" class="label">Case Rating:</div>
                </div>

                @for (case of caseRatingEnums | enumDisplay: finalReport.enumCaseRatingID; track case) {
                  <div fxFlex="40" fxLayout="column" class="flex-column" style="flex: 1; display: flex">
                    <div fxLayout="row" class="entry">{{case.ItemDisplayValue}}</div>
                  </div>
                }

              </div>
              <div fxLayout="row" style="margin-top: 3%; padding-top: 2%; flex: 1;">

                <div fxLayout="column" class="flex-column" style="flex: 1; display: flex; margin: 2%">
                  <div fxLayout="row" class="label-2">M</div>
                  @if (!finalReport) {
                    <div fxLayout="row" class="entry">No Data</div>
                  }
                  @if (finalReport) {
                    <div fxLayout="row" class="entry"></div>
                  }

                </div>

                <div fxLayout="column" class="flex-column" style="flex: 1; display: flex; margin: 2%">
                  <div fxLayout="row" class="label-2">MB</div>
                  @if (!finalReport) {
                    <div fxLayout="row" class="entry">No Data</div>
                  }
                  @if (finalReport) {
                    <div fxLayout="row" class="entry"></div>
                  }

                </div>

                <div fxLayout="column" class="flex-column" style="flex: 1; display: flex; margin: 2%">
                  <div fxLayout="row" class="label-2">D</div>
                  @if (!finalReport) {
                    <div fxLayout="row" class="entry">No Data</div>
                  }
                  @if (finalReport) {
                    <div fxLayout="row" class="entry"></div>
                  }

                </div>

                <div fxLayout="column" class="flex-column" style="flex: 1; display: flex; margin: 2%">
                  <div fxLayout="row" class="label-2">DB</div>
                  @if (!finalReport) {
                    <div fxLayout="row" class="entry">No Data</div>
                  }
                  @if (finalReport) {
                    <div fxLayout="row" class="entry"></div>
                  }

                </div>

                <div fxFlex="50" fxLayout="column" class="flex-column" style="flex: 1; display: flex; margin: 2%"></div>

              </div>
              <div  fxFlex="50" fxLayout="row">

                <div fxLayout="column" class="flex-column" style="flex: 1; display: flex; margin: 2%">
                  <div fxLayout="row" class="label-2">ML</div>
                  @if (!finalReport) {
                    <div fxLayout="row" class="entry">No Data</div>
                  }
                  @if (finalReport) {
                    <div fxLayout="row" class="entry"></div>
                  }

                </div>

                <div fxLayout="column" class="flex-column" style="flex: 1; display: flex; margin: 2%">
                  <div fxLayout="row" class="label-2">L</div>
                  @if (!finalReport) {
                    <div fxLayout="row" class="entry">No Data</div>
                  }
                  @if (finalReport) {
                    <div fxLayout="row" class="entry"></div>
                  }

                </div>

                <div fxLayout="column" class="flex-column" style="flex: 1; display: flex; margin: 2%">
                  <div fxLayout="row" class="label-2">DL</div>
                  @if (!finalReport) {
                    <div fxLayout="row" class="entry">No Data</div>
                  }
                  @if (finalReport) {
                    <div fxLayout="row" class="entry"></div>
                  }

                </div>

                <div fxLayout="column" class="flex-column" style="flex: 1; display: flex; margin: 2%">
                  <div fxLayout="row" class="label-2">D</div>
                  @if (!finalReport) {
                    <div fxLayout="row" class="entry">No Data</div>
                  }
                  @if (finalReport) {
                    <div fxLayout="row" class="entry"></div>
                  }

                </div>

                <div  fxFlex="50" fxLayout="column" class="flex-column" style="flex: 1; display: flex; margin: 2%">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div fxLayout="row" style="width: 100%; flex: 1 0 0" data-cy="recall-print-modal-recalls-section">
        <div fxLayout="column" style="width: 100%" data-cy="recall-print-modal-recalls-container">
          <div fxLayout="row" style="width: 100%; align-items: center">
          </div>
          @for (recall of recalls; track recall; let i = $index) {
            <div fxLayout="row" style="width: 100%" data-cy="recall-print-modal-recall-item">
              <div fxLayout="column" style="width: 100%">
                <mat-label style="font-size: medium; font-weight: bold" data-cy="recall-print-modal-recall-header">Recall {{i + 1}}: {{recall.xauditCreatedOn | date: "short":'PST'}}</mat-label>
                <div fxLayout="row"style="width: 100%">
                  @for (opt of restoredValues; track opt) {
                    <div fxLayout="column" style="flex: 1;" class="label">
                      @if (opt.ValidValueItemId === recall.enumEndoRecallToothResoredID) {
                        <p>Restored: {{opt.ItemDisplayValue}}</p>
                      }
                      <!--                  <p *ngIf="!recall.enumEndoRecallToothResoredID">N/A</p>-->
                    </div>
                  }
                  @for (opt of coronalValues; track opt) {
                    <div fxLayout="column" style="flex: 1;" class="label">
                      @if (opt.ValidValueItemId === recall.enumEndoRecallCoronalLeakID) {
                        <p>Coronal: {{opt.ItemDisplayValue}}</p>
                      }
                      <!--                  <p *ngIf="!recall.enumEndoRecallCoronalLeakID">N/A</p>-->
                    </div>
                  }
                  @for (opt of asymValues; track opt) {
                    <div fxLayout="column" style="flex: 1;" class="label">
                      @if (opt.ValidValueItemId === recall.enumEndoRecallAsymFuncID) {
                        <p>Asym/Func: {{opt.ItemDisplayValue}}</p>
                      }
                      <!--                  <p *ngIf="!recall.enumEndoRecallAsymFuncID">N/A</p>-->
                    </div>
                  }
                  @for (opt of lucencyValues; track opt) {
                    <div fxLayout="column" style="flex: 1 0 0; display: flex" class="label">
                      @if (opt.ValidValueItemId === recall.enumEndoRecallLucencyID) {
                        <p>Lucency Dec: {{opt.ItemDisplayValue}}</p>
                      }
                      <!--                  <p *ngIf="!recall.enumEndoRecallLucencyID">N/A</p>-->
                    </div>
                  }
                  @for (opt of pdlidValues; track opt) {
                    <div fxLayout="column" style="flex: 1 0 0; display: flex" class="label">
                      @if (opt.ValidValueItemId === recall.enumEndoRecallPDLID) {
                        <p>PDL: {{opt.ItemDisplayValue}}</p>
                      }
                      <!--                  <p *ngIf="!recall.enumEndoRecallPDLID">N/A</p>-->
                    </div>
                  }
                  @for (opt of pdlidValues; track opt) {
                    <div fxLayout="column" style="flex: 1 0 0; display: flex" class="label">
                      @if (opt.ValidValueItemId === recall.enumEndoRecallPalpSoreID) {
                        <p>Palp: {{opt.ItemDisplayValue}}</p>
                      }
                      <!--                  <p *ngIf="!recall.enumEndoRecallPalpSoreID">N/A</p>-->
                    </div>
                  }
                  @for (opt of percussValues; track opt) {
                    <div fxLayout="column" style="flex: 1 0 0; display: flex" class="label">
                      @if (opt.ValidValueItemId === recall.enumEndoRecallPercussID) {
                        <p>Percuss: {{opt.ItemDisplayValue}}</p>
                      }
                      <!--                  <p *ngIf="!recall.enumEndoRecallPercussID">N/A</p>-->
                    </div>
                  }
                  @for (opt of mobilityValues; track opt) {
                    <div fxLayout="column" style="flex: 1 0 0; display: flex" class="label">
                      @if (opt.ValidValueItemId === recall.enumEndoRecallMobilityID) {
                        <p>Mobility: {{opt.ItemDisplayValue}}</p>
                      }
                      <!--                  <p *ngIf="!recall.enumEndoRecallMobilityID">N/A</p>-->
                    </div>
                  }
                  @for (opt of sinusValues; track opt) {
                    <div fxLayout="column" style="flex: 1 0 0; display: flex" class="label">
                      @if (opt.ValidValueItemId === recall.enumEndoRecallSinusTrackID) {
                        <p>Sinus Tract: {{opt.ItemDisplayValue}}</p>
                      }
                      <!--                  <p *ngIf="!recall.enumEndoRecallSinusTrackID">N/A</p>-->
                    </div>
                  }
                </div>
                <div fxLayout="row">
                  @for (opt of probingValues; track opt) {
                    <div fxLayout="column" style="flex: 1 0 0; display: flex" class="label">
                      @if (opt.ValidValueItemId === recall.probingM_enumProbingDepthID) {
                        <p>M: {{opt.ItemDisplayValue}}</p>
                      }
                      <!--                  <p *ngIf="!recall.probingM_enumProbingDepthID">N/A</p>-->
                    </div>
                  }
                  @for (opt of probingValues; track opt) {
                    <div fxLayout="column" style="flex: 1 0 0; display: flex" class="label">
                      @if (opt.ValidValueItemId === recall.probingMB_enumProbingDepthID) {
                        <p>MB: {{opt.ItemDisplayValue}}</p>
                      }
                      <!--                  <p *ngIf="!recall.probingMB_enumProbingDepthID">N/A</p>-->
                    </div>
                  }
                  @for (opt of probingValues; track opt) {
                    <div fxLayout="column" style="flex: 1 0 0; display: flex" class="label">
                      @if (opt.ValidValueItemId === recall.probingB_enumProbingDepthID) {
                        <p>B: {{opt.ItemDisplayValue}}</p>
                      }
                      <!--                  <p *ngIf="!recall.probingB_enumProbingDepthID">N/A</p>-->
                    </div>
                  }
                  @for (opt of probingValues; track opt) {
                    <div fxLayout="column" style="flex: 1 0 0; display: flex" class="label">
                      @if (opt.ValidValueItemId === recall.probingDB_enumProbingDepthID) {
                        <p>DB: {{opt.ItemDisplayValue}}</p>
                      }
                      <!--                  <p *ngIf="!recall.probingDB_enumProbingDepthID">N/A</p>-->
                    </div>
                  }
                  @for (opt of probingValues; track opt) {
                    <div fxLayout="column" style="flex: 1 0 0; display: flex" class="label">
                      @if (opt.ValidValueItemId === recall.probingML_enumProbingDepthID) {
                        <p>ML: {{opt.ItemDisplayValue}}</p>
                      }
                      <!--                  <p *ngIf="!recall.probingML_enumProbingDepthID">N/A</p>-->
                    </div>
                  }
                  @for (opt of probingValues; track opt) {
                    <div fxLayout="column" style="flex: 1 0 0; display: flex" class="label">
                      @if (opt.ValidValueItemId === recall.probingL_enumProbingDepthID) {
                        <p>L: {{opt.ItemDisplayValue}}</p>
                      }
                      <!--                  <p *ngIf="!recall.probingL_enumProbingDepthID">N/A</p>-->
                    </div>
                  }
                  @for (opt of probingValues; track opt) {
                    <div fxLayout="column" style="flex: 1 0 0; display: flex" class="label">
                      @if (opt.ValidValueItemId === recall.probingDL_enumProbingDepthID) {
                        <p>DL: {{opt.ItemDisplayValue}}</p>
                      }
                      <!--                  <p *ngIf="!recall.probingDL_enumProbingDepthID">N/A</p>-->
                    </div>
                  }
                  @for (opt of probingValues; track opt) {
                    <div fxLayout="column" style="flex: 1 0 0; display: flex" class="label">
                      @if (opt.ValidValueItemId === recall.probingD_enumProbingDepthID) {
                        <p>D: {{opt.ItemDisplayValue}}</p>
                      }
                      <!--                  <p *ngIf="!recall.probingD_enumProbingDepthID">N/A</p>-->
                    </div>
                  }
                </div>
                @for (opt of findingValues; track opt) {
                  <div fxLayout="row">
                    @if (opt.ValidValueItemId === recall.enumEndoRecallCurrentFindingID) {
                      <p>Current Finding: {{opt.ItemDisplayValue}}</p>
                    }
                    <!--                <p *ngIf="!recall.enumEndoRecallCurrentFindingID">N/A</p>-->
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>

</div>
